// extracted by mini-css-extract-plugin
module.exports = {"EditorialTextReadMore":"styles_EditorialTextReadMore__jCOJp","text":"styles_text__V0G3w"};